import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import edititem from "../../../components/Images/edititem.svg";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import { IconEditFigma } from "../../../Assets/MyIcons";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import { FaEllipsisVertical } from "react-icons/fa6";


function Tv_Settings(props) {
  const [data, setData] = useState([]);
  const [tvsetting, setTvsetting] = useState("");
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // const [previous, setPrevious] = useState([]);
  // const [next, setNext] = useState([]);
  const [page, setPage] = useState(1);
  // const [toggle, setToggle] = useState(true);
  // const [isOff, setIsOff] = useState(false);

  const access_token = localStorage.getItem("access_token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data?.slice(indexOfFirstItem, indexOfLastItem);

  const fetchDatanextpre = () => {
    axios
      .get(
        `${process.env.REACT_APP_Baseurl}/admin/tv-settings/index?page=${page}`,
        {
          headers: headers,
        }
      )
      .then((res) => {
        const tvsettingData = res?.data?.TVSetting;
        setTvsetting(tvsettingData);
        if (tvsettingData.length > 0) {
          setData(tvsettingData);
          setLoading(false);
        } else {
          setData([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(async () => {
    fetchDatanextpre();
  }, [page]);

  return (
    <FormContainer>
      <Wrapper className="w-100">
        {loading ? (
          <>
            <table className="w-100">
              <thead>
                <tr>
                  <th className="table-column-heading">
                    <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0 ">Name</h5>
                  </th>
                  <th className="table-column-heading">
                    <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0 ">Action</h5>
                  </th>
                </tr>
              </thead>
            </table>
            <div className="text-center mt-3">
              <label>
                <Response_Loading_processing />
                Loading...
              </label>
            </div>
          </>
        ) : tvsetting?.length > 0 ? (
          <table className="w-100">
            <thead>
              <tr>
                <th className="table-column-heading">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0 ">Name</h5>
                </th>
                <th className="table-column-heading">
                  <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0 ">Action</h5>
                </th>
              </tr>
            </thead>
            <tbody>
              {currentItems?.map((item, index) => (
                <tr key={item?.id}>
                  <td>
                    <MessageLabel text={item?.name} />
                  </td>
                  <td>
                    <div className="editdropdown">
                      <span className="editdropdown-button">
                        <FaEllipsisVertical className="theme-text-color" />
                      </span>
                      <div className="editdropdown-menu">
                        <Link to={`/update_tvsetting/${item?.id}`} className="edit">
                          <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                          <MessageBox text={`Edit Tv`} classname='ms-2 theme-text-color'></MessageBox>
                        </Link>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <>
            <table className="w-100">
              <thead>
                <tr>
                  <th className="table-column-heading">
                    <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0 ">Name</h5>
                  </th>
                  <th className="table-column-heading">
                    <h5 className="theme-text-color theme-border-secondary-color pb-3 mb-3 mt-0 ">Action</h5>
                  </th>
                </tr>
              </thead>
            </table>
            <div className="text-center mt-3">
              <label>No TV Settings Available.</label>
            </div>
          </>
        )}
      </Wrapper>
    </FormContainer>

  );
}

export default Tv_Settings;
